(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu"] && !Shopify.designMode) return;
  try {
    (function () {
  try {
    var root = document.querySelector('.menu__list--{{ menu_id }}');
    if (!root) return;

    root.querySelectorAll('li .menu__item-title--first-level').forEach(function (row) {
      var parentLink = row.querySelector('a.menu__item-link--parent');
      if (!parentLink) return;

      // The theme uses a chevron element for toggling — reuse it
      var chevron = row.querySelector('.dropdown-icon--first-level, .dropdown-icon');

      function toggle(e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        // If chevron exists, dispatch its click so the theme’s own logic opens/closes
        if (chevron) {
          chevron.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        } else {
          // Fallback: add/remove an "is-open" class on the <li>
          var li = row.closest('li');
          if (li) li.classList.toggle('is-open');
          // Keep ARIA in sync
          var expanded = parentLink.getAttribute('aria-expanded') === 'true';
          parentLink.setAttribute('aria-expanded', (!expanded).toString());
        }
      }

      parentLink.addEventListener('click', toggle);
      parentLink.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggle(e);
      });
    });
  } catch (err) {
    console.warn('Parent-link override failed:', err);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
